// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"cef48ee6","498":"8c7f5c60","598":"1a96e1e8"}[chunkId] + ".chunk.js";
};